import script from "./TeamCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./TeamCard.vue?vue&type=script&setup=true&lang=ts"

import "./TeamCard.vue?vue&type=style&index=0&id=534c221f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-534c221f"]])

export default __exports__